import { FC } from "react";
import Link from "next/link";
import { Badge } from "@/app/components/shadcn/badge";
import FallbackImage from "@/app/components/elements/FallbackImage";
import { HeaderAccountMenuItem } from "@/app/lib/features/accountMenu/accountMenu.types";
import { trackGeneric } from "@/app/lib/tracking/interactions";

interface UserMenuItemsProps {
  items: HeaderAccountMenuItem[];
}

export const UserMenuItems: FC<UserMenuItemsProps> = ({ items }) => {
  return (
    <div className="space-y-1">
      {items.map((item) => (
        <Link
          key={item.slug}
          href={item.slug}
          onClick={() => trackGeneric(`account_menu_${item.slug.replace(/\//g, "").slice(0, 40)}`, "click")}
          className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors group"
        >
          <div className="relative w-4 h-4 shrink-0">
            <FallbackImage
              src={item.icon_full}
              alt={item.title}
              fill
              className="object-contain"
              fallbackClassName="object-contain opacity-60"
            />
          </div>
          <span className="text-sm text-gray-700 group-hover:text-gray-900 flex-1">
            {item.title}
          </span>
          {item.count > 0 && (
            <Badge variant="destructive" className="text-xs px-1.5 py-0.5">
              {item.count}
            </Badge>
          )}
        </Link>
      ))}
    </div>
  );
};
